import {createContext, useEffect, useReducer} from 'react';
import PropTypes from 'prop-types';
// utils
import axios from '../utils/axios';
import {isValidToken, setSession} from '../utils/jwt';
import {GoftinoSnippet} from '@mohsen007/react-goftino';
// ----------------------------------------------------------------------

const initialState = {
    isAuthenticated: false,
    isInitialized: false,
    isVerified: false,
    user: null,
};
const handlers = {
    INITIALIZE: (state, action) => {
        const {isAuthenticated, user, isVerified} = action.payload;
        return {
            ...state,
            isAuthenticated,
            isInitialized: true,
            isVerified,
            user,
        };
    },
    LOGIN: (state, action) => {
        const {user, isVerified} = action.payload;

        return {
            ...state,
            isAuthenticated: true,
            isVerified,
            user,
        };
    },
    LOGOUT: (state) => ({
        ...state,
        isAuthenticated: false,
        user: null,
    }),
    REGISTER: (state, action) => {
        const {message, status, isVerified} = action.payload;

        return {
            ...state,
            isAuthenticated: false,
            isVerified,
            message,
            status
        };
    },
    VERIFY: (state, action) => {
        const {user, isVerified} = action.payload;

        return {
            ...state,
            isAuthenticated: true,
            user,
            isVerified,
        };
    },
};

const reducer = (state, action) => (handlers[action.type] ? handlers[action.type](state, action) : state);

const AuthContext = createContext({
    ...initialState,
    method: 'jwt',
    login: () => Promise.resolve(),
    logout: () => Promise.resolve(),
    initialize: ()=> Promise.resolve(),
    registerMethod: () => Promise.resolve(),
    verifyMethod: () => Promise.resolve(),
});

// ----------------------------------------------------------------------

AuthProvider.propTypes = {
    children: PropTypes.node,
};

function AuthProvider({children}) {
    const [state, dispatch] = useReducer(reducer, initialState);
    const initialize = async () => {
        try {
            const access_token = window.localStorage.getItem('access_token');
            if (access_token && isValidToken(access_token)) {
                setSession(access_token);
                const response = await axios.get('/profile');
                const user = response.data.data;
                dispatch({
                    type: 'INITIALIZE',
                    payload: {
                        isAuthenticated: true,
                        isVerified: true,
                        user,
                    },
                });
            } else {
                dispatch({
                    type: 'INITIALIZE',
                    payload: {
                        isAuthenticated: false,
                        isVerified: true,
                        user: null,
                    },
                });
            }
        } catch (err) {
            console.error(err);
            dispatch({
                type: 'INITIALIZE',
                payload: {
                    isAuthenticated: false,
                    user: null,
                    isVerified: true
                },
            });
        }
    };

    useEffect(async () => {
        await initialize();
    }, []);

    const login = async (mobile) => {
        const response = await axios.post('/login', {
            mobile,
        });
        if (response.data.action === "verify") {

            dispatch({
                type: 'LOGIN',
                payload: {
                    isVerified: false,
                },
            });
        } else {
            const {access_token, user} = response.data.data;
            setSession(access_token);
            dispatch({
                type: 'LOGIN',
                payload: {
                    user,
                    isVerified: true,
                },
            });
        }

    };

    const registerMethod = async (mobile, password, full_name, birth_date) => {
        const response = await axios.post('/register', {
            mobile,
            password,
            full_name,
            birth_date,
        });
        const {message, status} = response.data;
        localStorage.setItem('mobile', mobile);
        dispatch({
            type: 'REGISTER',
            payload: {
                message,
                status,
                isVerified: false,
            },
        });
    };
    const verifyMethod = async (code,) => {
        const mobile = localStorage.getItem('mobile')
        const response = await axios.post('/verify', {
            mobile,
            code,
        });
        const {access_token, user} = response.data.data;
        setSession(access_token)
        dispatch({
            type: 'VERIFY',
            payload: {
                user,
                isVerified: true
            },
        });
        return response;
    };

    const logout = async () => {
        setSession(null);
        dispatch({type: 'LOGOUT'});
        localStorage.clear();

    };

    return (
        <AuthContext.Provider
            value={{
                ...state,
                method: 'jwt',
                login,
                logout,
                initialize,
                registerMethod,
                verifyMethod,
            }}
        >
            {children}
        </AuthContext.Provider>
    );
}

export {AuthContext, AuthProvider};
